function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { ComponentBootstrap } from "@demant/react-bootstrap";
import flexSpotSchema from "@demant/react-bootstrap/lib/schemas/flex-spot";
var MOBILE_BREAKPOINT = 768;
var componentSlider = function componentSlider(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var _useState = useState(window.innerWidth <= MOBILE_BREAKPOINT),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var isAutoplay = component.className.includes("slider-autoplay");
  var elements = settings.elements;
  var slidesData = elements.map(function (_ref2) {
    var items = _ref2.items;
    var desktopImage = items.find(function (item) {
      return item.tag === "desktop-image";
    });
    var mobileImage = items.find(function (item) {
      return item.tag === "mobile-image";
    });
    var text = items.find(function (item) {
      return item.type === "text";
    });
    return {
      desktopImage: desktopImage && desktopImage.image,
      mobileImage: mobileImage && mobileImage.image,
      html: text ? text.html.html.trim() : null
    };
  });
  var sliderOptions = {
    dots: true,
    infinite: true,
    autoplay: isAutoplay,
    autoplaySpeed: 6100,
    speed: 900,
    responsive: [{
      breakpoint: MOBILE_BREAKPOINT,
      settings: {
        arrows: false
      }
    }]
  };
  useEffect(function () {
    window.addEventListener("resize", function () {
      return setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/React.createElement(Slider, sliderOptions, slidesData.map(function (_ref3, i) {
    var desktopImage = _ref3.desktopImage,
      mobileImage = _ref3.mobileImage,
      html = _ref3.html;
    if (isMobile && (!mobileImage || !mobileImage.src)) {
      return null;
    } else if (!isMobile && (!desktopImage || !desktopImage.src)) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "banner-slide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "banner-slide-text",
      dangerouslySetInnerHTML: {
        __html: html
      }
    })), /*#__PURE__*/React.createElement("img", {
      className: "background-image",
      src: isMobile ? mobileImage.src : desktopImage.src
    }));
  })));
};
var myComponent = new ComponentBootstrap(".flex-spot.flexspot-slider");
myComponent.schemaData = flexSpotSchema;
myComponent.reactApp = componentSlider;
myComponent.run();